<template>
    <div class="beenCourse">
        <ul class="lessonBox" v-if="lessonList.length">
            <li
                class="col col-sm-6 col-md-4 lesson-li"  
                v-for="(item, index) in lessonList"
                :key="index">
                <div>
                    <div class="lessoncover">
                        <img v-if="item.work && item.work.cover" :class="item.work?'curp': ''" :src="item.work.cover" alt="" @click="goPlay(item)">
                        <img v-else-if="item.lesson && item.lesson.pptCover" :src="item.lesson.pptCover" alt="">
                        <img v-else :src="defaultCover" alt="" @click="goPlay(item)">
                    </div>
                    <div class="top">
                        <span class="flex">
                            <span>{{ item.lesson? item.lesson.name? item.lesson.name : ' ' : ' ' }}</span>
                        </span>
                        <span class="flex">
                            <span>{{ `${item.date? item.date : ''} ${item.week? hebdomad[item.week - 1] : ''}` }}</span>
                            <span>{{ `${item.startTime?item.startTime : ''}-${item.endTime? item.endTime : ''}` }}</span>
                        </span>
                        <span class="flex">
                            <div style="height: 35px;">
                                <img :src="item.teacherAvatar" alt="">
                                <span>{{item.teacherName }}</span>
                                <span class="lesson-one">{{ item.onlineTeaching? "线上课" : "线下课" }}</span>
                                <el-button v-if="item.taskList && item.taskList && item.taskList.length" type="success" @click="goHomeWork(item)" plain size="mini">作业</el-button>
                            </div>
                            <el-link
                            type="primary" 
                            @click="playLessonVideo(item)"
                            v-if="item.classVideos && item.classVideos.length">课堂回放</el-link>
                        </span>
                    </div>
                </div>
            </li>
        </ul>
        <span v-if="lessonList.length == 0" class="default">
            <img src="@/assets/icon/notdata.png" alt="">
            暂时没有已上课程
        </span>
        <el-pagination
         v-if="lessonList.length"
         background
         layout="prev, pager, next"
         :page-size="8"
         :total="totalElements"
         @current-change="handlePagination">
        </el-pagination>
        <el-dialog
          title="课堂回放"
          :close-on-click-modal="false"
          :visible.sync="videoDialogVisible"
          width="50%"
          @close="onClose">
            <video
             width="100%" 
             controlslist='nodownload noremoteplayback' 
             ref="videoPlayer" 
             :src="lessonVideo" 
             id="guideVideo" 
             controls="controls"></video>
        </el-dialog>
    </div>
</template>
<script>
import hmApi from '@/request/api/hm';
export default {
    data() {
        return {
            lessonList: [],
            hebdomad: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            defaultCover: require('@/assets/defaultWorkCover.png'),
            totalPages: 0,
            totalElements: 0,
            pageNumber: 1,
            videoDialogVisible: false,
            lessonVideo: ""
        }
    },
    created() {
        this.getLessonList();
    },
    methods: {
        //获取已上课列表
        getLessonList() {
            let params = {
                courseId: "",
                pageNumber: this.pageNumber,
                pageSize: 6,
                sortDirection: 1,
                sortName: 'createDate',
                lessonType: 'scratch',
                isShowFile: true,
            };
            hmApi.findClassRecordByStu(params, res => {
                if(res.succeed) {
                    this.lessonList = res.data.content;
                    this.totalElements = res.data.totalElements;
                }
            })
        },
        //去详情页
        goPlay(item) {
            if(item.work) {
                this.$router.push(`/workcontent/${item.work.id}`)
            }
        },
        //切换分页
        handlePagination(value) {
            this.pageNumber = value;
            this.getLessonList();
        },
        //课堂回放
        playLessonVideo(item) {
            if(item.classVideos && item.classVideos.length) {
                this.videoDialogVisible = true;
                this.lessonVideo = item.classVideos[0];
                this.$nextTick(() => {
                    if(this.$refs.videoPlayer){
                        this.$refs.videoPlayer.play();
                        this.$refs.videoPlayer['disablePictureInPicture'] = true;
                    }
                })
            }
        },
        onClose() {
            this.$refs.videoPlayer.pause();
            this.videoDialogVisible = false;
        },
        goHomeWork(item,) {
            this.$store.dispatch('lesson/set_prepareList', item.taskList);
            this.$router.push(`/resource?name=${item.lesson? item.lesson.name : ''}&type=homework&id=${item.id}`);
        },
    },
}
</script>
<style lang="scss">
.beenCourse {
    ul, li {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .el-pagination {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 25px 0;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: var(--theme-color);
        color: var(--theme-fontColor) !important;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: var(--theme-color);
    }
    .lessonBox {
        // display: flex;
        // flex-flow: row wrap;
        // justify-content: center;
        // align-items: center;
        min-height: 500px;
    }
    .lessonBox li {
        // width: 22%;
        padding:0 10px;
        margin-bottom: 30px;
        background: #fff;
        >div{
            border-radius: 10px;
            box-shadow: 0 10px 5px rgba(0, 0, 0, .2);
        }
        .top {
            padding: 10px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            img {
                width: 35px;
                /* max-height: 35px; */
                border-radius: 50%;
            }
            .flex {
                display: flex;
                flex-flow: row nowrap;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: 30px;
                margin-bottom: 10px;
            }
        }
    }
    .lessoncover {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        height: 142px;
        overflow: hidden;
    }
    .lessoncover img{
        width: 100%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        // height: 180px;
    }
    .lessonBox .bottom img {
        width: 100%;
    }
    .curp {
        cursor: pointer;
    }
    .default  {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 100px;
        color: #8a8a8a;
        font-size: 15px;
    }
    .default  img {
        width: 80px;
    }
    @media (min-width: 1020px) and (max-width: 1200px) {
        .lesson-li {
            width: 50%;;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/lesson/component/beenCourse.vue